/**
 * @fileoverview gRPC-Web generated client stub for somewear.api.v1
 * @enhanceable
 * @public
 */
// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.29.0
// source: api/user.proto
/* eslint-disable */
// @ts-nocheck
import * as grpcWeb from 'grpc-web';
import * as device_proto_pb from '../device_proto_pb'; // proto import: "device_proto.proto"
import * as user_proto_pb from '../user_proto_pb'; // proto import: "user_proto.proto"
import * as style_proto_pb from '../style_proto_pb'; // proto import: "style_proto.proto"
import * as api_user_pb from '../api/user_pb'; // proto import: "api/user.proto"
export class UserClient {
    client_;
    hostname_;
    credentials_;
    options_;
    constructor(hostname, credentials, options) {
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname.replace(/\/+$/, '');
        this.credentials_ = credentials;
        this.options_ = options;
    }
    methodDescriptorCreateExternalToken = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/CreateExternalToken', grpcWeb.MethodType.UNARY, api_user_pb.ExternalTokenRequest, api_user_pb.ExternalTokenResponse, (request) => {
        return request.serializeBinary();
    }, api_user_pb.ExternalTokenResponse.deserializeBinary);
    createExternalToken(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/CreateExternalToken', request, metadata || {}, this.methodDescriptorCreateExternalToken, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/CreateExternalToken', request, metadata || {}, this.methodDescriptorCreateExternalToken);
    }
    methodDescriptorCreateWorkspace = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/CreateWorkspace', grpcWeb.MethodType.UNARY, api_user_pb.CreateWorkspaceRequest, user_proto_pb.WorkspaceResponse, (request) => {
        return request.serializeBinary();
    }, user_proto_pb.WorkspaceResponse.deserializeBinary);
    createWorkspace(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/CreateWorkspace', request, metadata || {}, this.methodDescriptorCreateWorkspace, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/CreateWorkspace', request, metadata || {}, this.methodDescriptorCreateWorkspace);
    }
    methodDescriptorGetWorkspaces = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/GetWorkspaces', grpcWeb.MethodType.UNARY, api_user_pb.GetWorkspacesRequest, api_user_pb.GetWorkspacesResponse, (request) => {
        return request.serializeBinary();
    }, api_user_pb.GetWorkspacesResponse.deserializeBinary);
    getWorkspaces(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/GetWorkspaces', request, metadata || {}, this.methodDescriptorGetWorkspaces, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/GetWorkspaces', request, metadata || {}, this.methodDescriptorGetWorkspaces);
    }
    methodDescriptorGetWorkspaceAccounts = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/GetWorkspaceAccounts', grpcWeb.MethodType.UNARY, api_user_pb.GetWorkspaceAccountsRequest, user_proto_pb.UserResponseList, (request) => {
        return request.serializeBinary();
    }, user_proto_pb.UserResponseList.deserializeBinary);
    getWorkspaceAccounts(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/GetWorkspaceAccounts', request, metadata || {}, this.methodDescriptorGetWorkspaceAccounts, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/GetWorkspaceAccounts', request, metadata || {}, this.methodDescriptorGetWorkspaceAccounts);
    }
    methodDescriptorGetWorkspaceDevices = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/GetWorkspaceDevices', grpcWeb.MethodType.UNARY, api_user_pb.GetWorkspaceDevicesRequest, device_proto_pb.DeviceList, (request) => {
        return request.serializeBinary();
    }, device_proto_pb.DeviceList.deserializeBinary);
    getWorkspaceDevices(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/GetWorkspaceDevices', request, metadata || {}, this.methodDescriptorGetWorkspaceDevices, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/GetWorkspaceDevices', request, metadata || {}, this.methodDescriptorGetWorkspaceDevices);
    }
    methodDescriptorJoinWorkspace = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/JoinWorkspace', grpcWeb.MethodType.UNARY, api_user_pb.JoinWorkspaceRequest, user_proto_pb.WorkspaceResponse, (request) => {
        return request.serializeBinary();
    }, user_proto_pb.WorkspaceResponse.deserializeBinary);
    joinWorkspace(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/JoinWorkspace', request, metadata || {}, this.methodDescriptorJoinWorkspace, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/JoinWorkspace', request, metadata || {}, this.methodDescriptorJoinWorkspace);
    }
    methodDescriptorSignIn = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/SignIn', grpcWeb.MethodType.UNARY, user_proto_pb.SignInRequest, user_proto_pb.SignInResponse, (request) => {
        return request.serializeBinary();
    }, user_proto_pb.SignInResponse.deserializeBinary);
    signIn(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/SignIn', request, metadata || {}, this.methodDescriptorSignIn, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/SignIn', request, metadata || {}, this.methodDescriptorSignIn);
    }
    methodDescriptorSignUp = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/SignUp', grpcWeb.MethodType.UNARY, user_proto_pb.SignUpRequest, user_proto_pb.SignInResponse, (request) => {
        return request.serializeBinary();
    }, user_proto_pb.SignInResponse.deserializeBinary);
    signUp(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/SignUp', request, metadata || {}, this.methodDescriptorSignUp, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/SignUp', request, metadata || {}, this.methodDescriptorSignUp);
    }
    methodDescriptorUpdateUserPassword = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/UpdateUserPassword', grpcWeb.MethodType.UNARY, api_user_pb.UpdateUserPasswordRequest, api_user_pb.UpdateUserPasswordResponse, (request) => {
        return request.serializeBinary();
    }, api_user_pb.UpdateUserPasswordResponse.deserializeBinary);
    updateUserPassword(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/UpdateUserPassword', request, metadata || {}, this.methodDescriptorUpdateUserPassword, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/UpdateUserPassword', request, metadata || {}, this.methodDescriptorUpdateUserPassword);
    }
    methodDescriptorRefreshAccessToken = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/RefreshAccessToken', grpcWeb.MethodType.UNARY, api_user_pb.RefreshAccessTokenRequest, user_proto_pb.SignInResponse, (request) => {
        return request.serializeBinary();
    }, user_proto_pb.SignInResponse.deserializeBinary);
    refreshAccessToken(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/RefreshAccessToken', request, metadata || {}, this.methodDescriptorRefreshAccessToken, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/RefreshAccessToken', request, metadata || {}, this.methodDescriptorRefreshAccessToken);
    }
    methodDescriptorSignOut = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/SignOut', grpcWeb.MethodType.UNARY, api_user_pb.SignOutRequest, api_user_pb.SignOutRequest, (request) => {
        return request.serializeBinary();
    }, api_user_pb.SignOutRequest.deserializeBinary);
    signOut(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/SignOut', request, metadata || {}, this.methodDescriptorSignOut, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/SignOut', request, metadata || {}, this.methodDescriptorSignOut);
    }
    methodDescriptorUpdateWorkspaceAccounts = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/UpdateWorkspaceAccounts', grpcWeb.MethodType.UNARY, api_user_pb.UpdateWorkspaceAccountList, api_user_pb.UpdateWorkspaceAccountsResponse, (request) => {
        return request.serializeBinary();
    }, api_user_pb.UpdateWorkspaceAccountsResponse.deserializeBinary);
    updateWorkspaceAccounts(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/UpdateWorkspaceAccounts', request, metadata || {}, this.methodDescriptorUpdateWorkspaceAccounts, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/UpdateWorkspaceAccounts', request, metadata || {}, this.methodDescriptorUpdateWorkspaceAccounts);
    }
    methodDescriptorGetOrganizations = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/GetOrganizations', grpcWeb.MethodType.UNARY, api_user_pb.GetOrganizationsRequest, api_user_pb.GetOrganizationsResponse, (request) => {
        return request.serializeBinary();
    }, api_user_pb.GetOrganizationsResponse.deserializeBinary);
    getOrganizations(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/GetOrganizations', request, metadata || {}, this.methodDescriptorGetOrganizations, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/GetOrganizations', request, metadata || {}, this.methodDescriptorGetOrganizations);
    }
    methodDescriptorGetAssets = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/GetAssets', grpcWeb.MethodType.UNARY, api_user_pb.GetAssetsRequest, api_user_pb.GetAssetsResponse, (request) => {
        return request.serializeBinary();
    }, api_user_pb.GetAssetsResponse.deserializeBinary);
    getAssets(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/GetAssets', request, metadata || {}, this.methodDescriptorGetAssets, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/GetAssets', request, metadata || {}, this.methodDescriptorGetAssets);
    }
    methodDescriptorGetWorkspaceAssets = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/GetWorkspaceAssets', grpcWeb.MethodType.UNARY, api_user_pb.GetAssetsRequest, api_user_pb.GetAssetsResponse, (request) => {
        return request.serializeBinary();
    }, api_user_pb.GetAssetsResponse.deserializeBinary);
    getWorkspaceAssets(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/GetWorkspaceAssets', request, metadata || {}, this.methodDescriptorGetWorkspaceAssets, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/GetWorkspaceAssets', request, metadata || {}, this.methodDescriptorGetWorkspaceAssets);
    }
    methodDescriptorGetSelfAccounts = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/GetSelfAccounts', grpcWeb.MethodType.UNARY, api_user_pb.GetSelfAccountsRequest, api_user_pb.GetSelfAccountsResponse, (request) => {
        return request.serializeBinary();
    }, api_user_pb.GetSelfAccountsResponse.deserializeBinary);
    getSelfAccounts(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/GetSelfAccounts', request, metadata || {}, this.methodDescriptorGetSelfAccounts, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/GetSelfAccounts', request, metadata || {}, this.methodDescriptorGetSelfAccounts);
    }
    methodDescriptorAcceptTerms = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/AcceptTerms', grpcWeb.MethodType.UNARY, api_user_pb.AcceptTermsRequest, api_user_pb.AcceptTermsResponse, (request) => {
        return request.serializeBinary();
    }, api_user_pb.AcceptTermsResponse.deserializeBinary);
    acceptTerms(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/AcceptTerms', request, metadata || {}, this.methodDescriptorAcceptTerms, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/AcceptTerms', request, metadata || {}, this.methodDescriptorAcceptTerms);
    }
    methodDescriptorUpdateStyle = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/UpdateStyle', grpcWeb.MethodType.UNARY, style_proto_pb.UpdateStyleSettingsRequest, user_proto_pb.UserIdentityResponse, (request) => {
        return request.serializeBinary();
    }, user_proto_pb.UserIdentityResponse.deserializeBinary);
    updateStyle(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/UpdateStyle', request, metadata || {}, this.methodDescriptorUpdateStyle, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/UpdateStyle', request, metadata || {}, this.methodDescriptorUpdateStyle);
    }
    methodDescriptorRenameAsset = new grpcWeb.MethodDescriptor('/somewear.api.v1.User/RenameAsset', grpcWeb.MethodType.UNARY, api_user_pb.RenameAssetRequest, api_user_pb.RenameAssetRequest, (request) => {
        return request.serializeBinary();
    }, api_user_pb.RenameAssetRequest.deserializeBinary);
    renameAsset(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.User/RenameAsset', request, metadata || {}, this.methodDescriptorRenameAsset, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.User/RenameAsset', request, metadata || {}, this.methodDescriptorRenameAsset);
    }
}
//# sourceMappingURL=UserServiceClientPb.js.map